import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { WidgetID } from '../../models/widget.model';

// identifier
export const PAGINATION_SLICE_ID = 'pagination';

interface WidgetPaginationState {
  [key: string]: PaginatedWidget;
}

export interface PaginatedWidget {
  skip: number;
  take: number;
  total: number;
}

// default state
const initialState: WidgetPaginationState = {};

//slice
const paginationSlice = createSlice({
  name: PAGINATION_SLICE_ID,
  initialState,
  reducers: {
    setPagination: (
      state: WidgetPaginationState,
      action: PayloadAction<{ id: WidgetID } & PaginatedWidget>
    ) => {
      state[action.payload.id] = {
        ...action.payload,
      };
    },
    resetPagination: (state: WidgetPaginationState) => {
      // eslint-disable-next-line
      state = {};
    },
  },
});

//selectors

export const selectPagination = createSelector(
  [(state: RootState) => state.pagination, (_: RootState, widgetId: WidgetID) => widgetId],
  (pagination, widgetId): PaginatedWidget | null => {
    return pagination[widgetId] ? pagination[widgetId] : null;
  }
);

//actions
export const { setPagination, resetPagination } = paginationSlice.actions;

//reducer
export default paginationSlice;
